module.exports = __webpack_public_path__ + "img/nova-post1.f9d1a7be.jpeg";